<template>
    <div class="row align-items-center justify-content-center" style="min-height: 100vh">
        <div class="col-12 col-md-8 col-xl-6">

            <form v-if="!success" @submit.prevent="submit" class="mt-3">
                <Card>
                    <h5 class="font-weight-bold mb-heading">{{ __('Remind password') }}</h5>

                    <FormInput
                        class="form-input-password"
                        :label="__('Email')"
                        autofocus
                        name="email"
                        type="email"
                        v-model="email"
                        v-validate="'required|email'"
                    />
                </Card>

                <div class="card-after">
                    <router-link
                        class="btn btn-secondary btn-sm w-25"
                        to="/login"
                    >
                        {{ __('Back') }}
                    </router-link>

                    <button
                        v-if="loading"
                        class="btn btn-primary btn-sm w-25"
                        disabled
                    >
                        {{ __('Working...') }}
                    </button>

                    <button
                        v-else
                        class="btn btn-primary btn-sm w-25"
                        type="submit"
                    >
                        {{ __('Remind') }}
                    </button>
                </div>
            </form>

            <Card v-else>
                <div class="d-flex flex-column align-items-center">
                    <h3>{{ __('Remind sent') }}</h3>

                    <div class="my-2">
                        <p>{{ __('Check your inbox and follow instructions to reset your password.') }}</p>
                    </div>

                    <router-link
                        class="btn btn-sm btn-primary w-50"
                        to="/login"
                    >
                        {{ __('Back') }}
                    </router-link>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
export default {
  name: 'PasswordReset',

  data () {
    return {
      email: null,
      success: false,
      loading: false
    }
  },

  methods: {
    submit () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          this.errors.clear()
          this.loading = true

          this.$api.auth.resetPassword(this.email).then((res) => {
            if (res.status === 200) {
              this.success = true
            }
          }).catch((response) => {
            this.setErrorsFromResponse(response)
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>
